import { DeeplinkKeys } from '@/consts/deepLinks';
import { getContext } from '@/context';

/**
 * Removes presetJsonUrl query parameter from URL after auto-generation
 * completes (success or failure) to prevent re-triggering on page reload.
 */
const removePresetJsonUrlFromUrl = () => {
  try {
    const { params, route } = getContext().general.location.getState();

    if (!params[DeeplinkKeys.presetJsonUrl]) {
      return;
    }

    const { [DeeplinkKeys.presetJsonUrl]: _, ...remainingParams } = params;

    getContext().general.location.dispatch({
      route,
      params: remainingParams,
    });
  } catch {
    // SDK not available, silently fail
  }
};

export { removePresetJsonUrlFromUrl };
